import { Button, Card, Table, Title } from '@mantine/core';
import { variants } from '@uag/react-core';
import { t } from 'i18next';

import { Scenario } from 'models';
import { ScenarioInput } from './ScenarioInput';

type ScenarioTableProps = {
    value: Scenario[],
    onChange: (value: Scenario[]) => void
}

export const ScenarioTable = ({ value: scenarios, onChange }: ScenarioTableProps) => {
    const heads = ['', t('ambientTemperature'), t('freshConcreteTemperature'), t('concreteMixture'), t('calibrationCurve'), t('concretePrice')];
    return (
        <Card className="flex flex-col gap-md p-6 w-full" >
            <div className="flex justify-between w-full">
                <Title order={4}>{t('scenarios')}</Title>
                <Button
                    disabled={scenarios.length >= 3}
                    variant={variants.button.secondary}
                    onClick={() => {
                        const lastScenario = scenarios[scenarios.length - 1];
                        onChange([...scenarios,
                        {
                            id: Date.now() % 1000000,
                            ambientTemperature: lastScenario.ambientTemperature,
                            freshConcreteTemperature: lastScenario.freshConcreteTemperature,
                            concreteMixture: undefined,
                            calibrationCurve: undefined,
                            concretePrice: lastScenario.concretePrice
                        }]);
                    }} >
                    {t('addScenario')}
                </Button>
            </div>
            <Table>
                <Table.Thead>
                    <Table.Tr>
                        {heads.map((head) =>
                            <Table.Th key={head} className="text-base text-text-default">{head}</Table.Th>)}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {scenarios.map((scenario, index) => (
                        <ScenarioInput
                            key={scenario.id}
                            canDelete={scenarios.length > 1}
                            title={`${t('scenario')} ${index + 1}`}
                            value={scenario}
                            onChange={(value) => onChange(scenarios.map(s => s.id !== scenario.id ? s : value))}
                            onDelete={() => onChange(scenarios.filter((s) => s.id !== scenario.id))}
                        />
                    ))}
                </Table.Tbody>
            </Table>
        </Card >
    );
};